/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum LaboratoryCategoryEnum {
    Technological = 'Technological',
    Informatic = 'Informatic'
}

export function LaboratoryCategoryEnumFromJSON(json: any): LaboratoryCategoryEnum {
    return LaboratoryCategoryEnumFromJSONTyped(json, false);
}

export function LaboratoryCategoryEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaboratoryCategoryEnum {
    return json as LaboratoryCategoryEnum;
}

export function LaboratoryCategoryEnumToJSON(value?: LaboratoryCategoryEnum | null): any {
    return value as any;
}

